/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export interface FormulaValidationResult {
  valid: boolean;
  errorId?: string;
  errorParams?: Hash<any>;
  position?: number;
}

export interface FormulaRewriteResult extends FormulaValidationResult {
  valid: boolean;
  rewritten?: string;
}

export class FormulaParseError extends Error {
  constructor(public errorId: string,
              public errorParams: Hash<any> = {},
              public position?: number) {
    super();
  }
}

export enum FormulaParseErrorType {
  UNEXPECTED_TOKEN = 'UNEXPECTED_TOKEN',
  EXPECTED_CLOSING_BRACKET = 'EXPECTED_CLOSING_BRACKET',
  UNEXPECTED = 'UNEXPECTED',
  EXPECTED_FUNCTION_ARGUMENT = 'EXPECTED_FUNCTION_ARGUMENT',
  UNKNOWN_FUNCTION_NAME = 'UNKNOWN_FUNCTION_NAME',
  ILLEGAL_NUMBER_OF_ARGUMENTS = 'ILLEGAL_NUMBER_OF_ARGUMENTS',
  UNKNOWN_VARIABLE_NAME = 'UNKNOWN_VARIABLE_NAME',
}
